/**
 * Sticky section menu (.section-nav): slides out of the way while scrolling
 * down, back in on the first scroll up, so it stops eating screen space on
 * long pages. Only hides once the pill is actually stuck to the top; while
 * it still sits in its natural spot over the hero it never moves.
 */
// Sustained scroll needed before reacting. Any direction change resets the
// accumulator, so trackpad/momentum jitter (tiny opposite-direction spikes)
// never toggles the menu back and forth.
const HIDE_AFTER = 120; // px scrolled down before hiding
// Low on purpose: mobile browsers swallow the start of an upward gesture
// re-revealing the address bar, so a high threshold feels sluggish there.
// The 2-event streak below is what filters out single jitter spikes.
const SHOW_AFTER = 8;   // px scrolled up before showing
const SHOW_STREAK = 2;  // consecutive upward scroll events required

function init() {
    const nav = document.querySelector('.section-nav');
    if (!nav) {
        return;
    }

    let lastY = window.scrollY;
    let acc = 0;
    let upStreak = 0;
    let ticking = false;
    // Sticky offset from the CSS (top: 16px); +1 covers subpixel rounding
    const stickyTop = (parseFloat(window.getComputedStyle(nav).top) || 0) + 1;

    const update = () => {
        ticking = false;
        const y = window.scrollY;
        const diff = y - lastY;
        lastY = y;

        if (diff === 0) {
            return;
        }
        if ((acc > 0) !== (diff > 0)) {
            acc = 0;
        }
        acc += diff;
        upStreak = diff < 0 ? upStreak + 1 : 0;

        // Stuck = the pill has left its natural spot over the hero and is
        // pinned to the viewport top (already negative while hidden)
        const stuck = nav.getBoundingClientRect().top <= stickyTop;

        // Reset after each toggle: flipping back needs a fresh sustained
        // scroll in the other direction, so the two states can never flap
        // Never hide while a menu link holds keyboard focus
        if (acc > HIDE_AFTER && stuck && !nav.contains(document.activeElement)) {
            nav.classList.add('is-hidden');
            acc = 0;
        } else if (acc < -SHOW_AFTER && upStreak >= SHOW_STREAK) {
            nav.classList.remove('is-hidden');
            acc = 0;
        }
    };

    window.addEventListener('scroll', () => {
        if (!ticking) {
            ticking = true;
            window.requestAnimationFrame(update);
        }
    }, { passive: true });

    // Keyboard users tabbing into the menu must always see it
    nav.addEventListener('focusin', () => nav.classList.remove('is-hidden'));
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
